module.exports = __webpack_public_path__ + "img/xkool_gray.b0f301bc.png";